<template>
  <div class="navbar">
    <div style="width: 100%;height:0.8rem" v-if="$route.path=='/specialFundDetails' || $route.path=='/specialFundNewsDetails'" :style="{backgroundColor: themeColor}"></div>
    <div class="top" v-if="screenWidth>900">
      <div style="display: flex;float: left;height: 3rem;align-items: center;">
        <a href="/">
          <img class="logo" src="../../assets/img/logo.jpg" />
          <div class="special-logo" v-if="fundLog && $route.path == '/specialFundDetails'">
            <img :src="fundLog" width="100%" height="130%" style="position: relative;top: -0.35rem;" />
          </div>
        </a>
      </div>
      <div class="search-language">
        <div class="search-div">
          <el-input v-model="searchInput" :placeholder="$t('PleaseInput')" class="search-input"></el-input>
          <span @click="goToSearch()"><i class="el-icon-search" style="font-weight: 600;"></i></span>
        </div>
        <span style="margin-left: 1rem;line-height: 3rem;cursor: pointer;" @click="switchLanguage"><span :class="{'language-no-click':language == 'en'}">中文</span> | <span :class="{'language-no-click':language == 'zh'}">EN</span></span>
      </div>
    </div>
    <div class="top1" v-if="screenWidth<=900">
      <div style="float: left;">
        <a href="/" v-if="fundLog && $route.path == '/specialFundDetails' && screenWidth<540">
          <img class="logo1" :src="fundLog" />
        </a>
        <a href="/" v-else>
          <img class="logo1" src="../../assets/img/logo/logo.png" />
          <div class="special-logo1" v-if="fundLog && $route.path == '/specialFundDetails'">
            <img :src="fundLog" />
          </div>
        </a>
      </div>
      <div class="search-language1">
        <span style="margin-left: 1rem;line-height: 3rem;cursor: pointer;float:left" @click="switchLanguage"><span :class="{'language-no-click':language == 'en'}">中文&nbsp</span> | <span :class="{'language-no-click':language == 'zh'}">&nbspEN</span></span>
        <img src="../../assets/img/search-img.png" style="" @click="showAD('right')" />
        <img src="../../assets/img/menu-img.png" style="" @click="showAD('left')" />
        <!-- <i :class="!isShowAD?'el-icon-menu':'el-icon-close'" style="color: #AA221D;" @click="showAD('left')"></i> -->
      </div>
    </div>
    <div style="clear:both"></div>
    <div class="top-menu-small-bottom" v-if="isShowAD&&screenWidth<=900">
      <div v-if="showName == 'left'">
        <div v-for="(item,index) in menuList" class="top-menu-small-item" :key="item.id">
          <div @click="goToHref(item,true)" :class="{'dropdown-item-active': item.name == clickMenuName}">{{ item.name }}</div> <span v-show="item.child" style="font-size:2rem;float:right" @click="changeChildShow">
            <i :class="!showChild?'el-icon-arrow-right':'el-icon-arrow-down'" style="position: relative;top:-2rem"></i> </span>
          <div v-if="item.child&&showChild" style="width: 96%;padding: 2rem 0;">
            <div class="top-menu-small-item" :class="{'dropdown-item-active': childItem.href == clickMenuUrl}" v-for="(childItem,childIndex) in item.child" @click="goToHref(childItem,true)" :key="childItem.id">
              {{ childItem.name }}
              <el-divider v-if="childIndex < item.child.length - 1"></el-divider>
            </div>

          </div>
          <el-divider v-if="index < menuList.length - 1"></el-divider>
        </div>
      </div>
      <div v-else>
        <div style="width: 100%;height:4rem">
          <el-input suffix-icon="el-icon-search" v-model="searchInput" :placeholder="$t('PleaseInput')" @keyup.enter.native="goToSearch" style="width: 90%;margin:auto 5%"></el-input>
        </div>
      </div>

    </div>

    <!-- <div class="top-menu-small" v-if="screenWidth<900&&$route.path!='/specialFundDetails' && $route.path!='/specialFundNewsDetails'">

      <div style="clear: both;"></div>

    </div> -->
    <div class="menu-box">
      <div class="top-menu" v-if="screenWidth>900 && $route.path!='/specialFundDetails' && $route.path!='/specialFundNewsDetails'">
        <div class="menu-item" v-for="item in menuList" :key="item.id" :style="{width: 100/(menuList.length)+'%'}">
          <div style="cursor: pointer;overflow: hidden;height: 4rem;" :style="{width: (item.name.length)+'rem'}" :class="{'menu-active': item.name == clickMenuName}" @click="goToHref(item,false)">{{ item.name }}</div>
          <div class="menu-item-hover" v-show="item.child" style="width: 100%;background-color: white;position: absolute;top: 4rem;">
            <div class="menu-item-child" :class="{'menu-child-active': childItem.href == clickMenuUrl}" v-for="childItem in item.child" @click="goToHref(childItem,false)" :key="childItem.id">{{ childItem.name }}</div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['clickMenuName', 'clickMenuUrl', 'themeColor', 'fundLog', 'screenWidth']),
    menuList() {
      return [
        {
          name: this.$t('Home'),
          id: '1',
          href: '/',
          hrefList: [
            '/',
          ]
        },
        {
          name: this.$t('News'),
          id: '2',
          href: '/news',
          hrefList: [
            '/news',
            '/newsDetails',
          ]
        },
        {
          name: this.$t('OrganizationalProfile'),
          id: '3',
          href: '/organizationalProfile/foundationIntroduction',
          hrefList: [
            '/organizationalProfile/foundationIntroduction',
            '/organizationalProfile/foundingDirectorUnit',
            '/organizationalProfile/organizationStructure',
            '/organizationalProfile/council',
          ],
          child: [
            {
              name: this.$t('FoundationIntroduction'),
              id: '31',
              href: '/organizationalProfile/foundationIntroduction'
            },
            {
              name: this.$t('FoundingDirectorUnit'),
              id: '32',
              href: '/organizationalProfile/foundingDirectorUnit'
            },
            {
              name: this.$t('Council'),
              id: '33',
              href: '/organizationalProfile/council'
            },
            {
              name: this.$t('OrganizationStructure'),
              id: '34',
              href: '/organizationalProfile/organizationStructure'
            }
          ]
        },
        {
          name: this.$t('FoundationProject'),
          id: '4',
          href: '/foundationProject',
          hrefList: [
            '/foundationProject',
            '/foundationProjectDetails',
          ]
        },
        {
          name: this.$t('SpecialFund'),
          id: '5',
          href: '/specialFund',
          hrefList: [
            '/specialFund',
            '/specialFundDetails',
            '/specialFundNewsDetails',
          ]
        },
        // {
        //   name: this.$t('KidsGallery'),
        //   id: '6',
        //   href: '/kidsGallery',
        //   hrefList: [
        //     '/kidsGallery',
        //     '/kidsGalleryDetails',
        //   ]
        // },
        {
          name: this.$t('Download'),
          id: '7',
          href: '/toDownload',
          hrefList: [
            '/toDownload',
          ]
        },
        {
          name: this.$t('ContactUs'),
          id: '8',
          href: '/contactUs',
          hrefList: [
            '/contactUs',
          ]
        }

      ];
    }
  },
  data() {
    return {
      activeIndex: '1',
      img1: require('../../assets/img/weixin.png'),
      img2: require('@/assets/img/weibo.png'),
      searchQuery: '',
      language: localStorage.getItem('locale') || 'zh',
      searchInput: '',
      showName: '',
      isShowAD: false,
      showChild: false,
    };
  },
  mounted() {
  },
  methods: {
    showAD(name) {
      this.showName = name;
      this.isShowAD = !this.isShowAD;
    },
    changeChildShow() {
      this.showChild = !this.showChild;
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    switchLanguage() {
      this.language = this.language === 'zh' ? 'en' : 'zh';
      // 此处做了语言选择记录，存在localStorage中，这里的作用只有一个当我重新请求页面
      //的时候先取localStorage的记录值
      localStorage.setItem('locale', this.language)
      this.$i18n.locale = this.language; // 修改页面需要显示的语言
      location.reload();
    },
    goToHref(item, type) {
      // console.log('item', item);

      this.$router.push(item.href);
      if (type) {
        this.isShowAD = !this.isShowAD
      }
    },
    handleClick() {
      alert('button click');
    },
    goToSearch() {
      // console.log("111");

      if (this.searchInput) {
        this.$router.push({ path: '/news', query: { search: this.searchInput } });
        this.isShowAD = !this.isShowAD
      }
    },
  },
};
</script>

<style lang="less" scoped>
.navbar {
  width: 100%;
  color: black;
}

.top1 {
  width: 100%;
  padding: 1rem;
  background: white;
  height: 5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .logo1 {
    margin-right: 1rem;
    cursor: pointer;
    width: 11rem;
  }
  .special-logo1 {
    padding-left: 1rem;
    cursor: pointer;
    width: 11rem;
    height: 2.3rem;
    float: left;
    border-left: 1px solid #e7e7e7;
    position: relative;
    top: 0.7rem;
  }
  .logo-small {
    display: none;
    cursor: pointer;
    width: 1rem;
    float: left;
  }

  .search-language1 {
    font-size: 1.3rem;
    font-weight: 800;
    img {
      width: 1.8rem;
      position: relative;
      top: 0.5rem;
      font-weight: 800;
      color: #c2a552;
      margin-left: 1rem;
    }
  }
}

.top {
  width: calc(100% - 4rem);
  padding: 1rem 2rem;
  background: white;
  height: 3.1rem;
  .logo {
    margin-right: 1rem;
    cursor: pointer;
    width: 10rem;
    float: left;
  }
  .special-logo {
    padding-left: 1rem;
    cursor: pointer;
    width: 10rem;
    // height: 2.3rem;
    float: left;
    border-left: 1px solid #e7e7e7;
    position: relative;
    top: 0.7rem;
  }
  .logo-small {
    display: none;
    cursor: pointer;
    width: 1rem;
    float: left;
  }

  .search-language {
    float: right;
    .search-div {
      float: left;
      width: 13rem;
      height: 3rem;
      background: #f7f8f9;
      border-radius: 1.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      ::v-deep .el-input__inner {
        width: 60% !important;
        border: none;
        height: 2.5rem;
        outline: none;
        font-size: 1rem;
        padding: 0;
        margin-left: 1rem;
        background: #f7f8f9;
      }
    }
  }
}

.menu-box{
  width: 100%;
  background-color: #b8210f; /* 红色背景 */
}
.top-menu {
  clear: both;
  background-color: #b8210f; /* 红色背景 */
  color: white;
  width: 80%;
  height: 4rem;
  line-height: 4rem;
  margin: 0 auto;
  // overflow: hidden;
  .menu-item {
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 1rem;
    font-weight: 500;
    position: relative;
  }
  .menu-active {
    text-align: center;
    height: calc(4rem - 3px);
    border-bottom: white 3px solid;
    box-sizing: border-box;
  }
  .menu-item:hover {
    background: #fff;
    font-weight: 800;
    color: #aa221d;
  }
}

.language-no-click {
  color: #9a9fb1;
}
.menu-item-hover {
  display: none;
}
.menu-item:hover .menu-item-hover {
  z-index: 9999;
  display: block;
}
.menu-item-child:hover {
  background-color: #b8210f;
  color: white;
}
.menu-item-child {
  color: black;
  line-height: 3rem;
  cursor: pointer;
}
.menu-child-active {
  background-color: #b8210f;
  color: white;
  cursor: pointer;
}
.search-input {
  width: 75%;
}

::v-deep .top .search-language .search-div .el-input__inner {
  width: 80% !important;
}
.dropdown-item-active {
  // background-color: #aa221d !important;
  // color: white;
  font-size: 1.5rem !important;
  font-weight: 800;
}

.top-menu-small {
  z-index: 9999;
  position: relative;
  // display: none;
  // float: right;
  // margin-right: 1rem;
  // line-height: 3rem;
  // cursor: pointer;
  // width: 100%;
  // background-color: #B8210F; /* 红色背景 */
  // color: white;
  // width: 100%;
  // height: 3rem;
}
.top-menu-small-main {
  z-index: 9999;
  padding: 1rem !important;
  height: 4rem;
  box-sizing: border-box;
  line-height: 4rem;
  width: 100%;
  color: red;
  float: left;
}
.top-menu-small-bottom {
  width: 100%;
  background: #ffff;
  z-index: 9999;
  position: absolute;
  top: 5rem;
  padding: 2rem 0;
}
.top-menu-small-item {
  padding: 0 2rem;
  font-size: 1.3rem;
  line-height: 2rem;
  color: #1d1f23 !important;
}
</style>